import Tip from 'components/tip/Tip';
import styled from 'styled-components';

import { black, blue, textGray } from '../../modules/colors';
import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${spacing.xl}px;
  ${(props) => props.extraSpacing && `margin-top: ${spacing.md}px;`}

  > * {
    width: 100%;
  }
`;

export const Label = styled.label`
  font-size: ${fonts.md}px;
  color: ${black};
  display: block;
`;

export const Element = styled.div`
  ${(props) => (props.hidden ? 'display: none;' : 'display:block;')}
`;

export const HintMessage = styled.div`
  font-size: ${fonts.xs}px;
  color: ${textGray};
  margin-bottom: ${spacing.sm}px;
`;

export const LabelWrapper = styled(Label)`
  display: flex;
  align-items: center;
  ${(props) =>
    props.labelLink &&
    `justify-Content:space-between; margin-bottom:${spacing.md}px;`}

  > img {
    margin-right: ${spacing.md}px;
  }

  > a {
    color: ${blue};
  }
`;

export const CustomTip = styled(Tip)`
  margin-left: ${spacing.md}px;
`;

export const LabelWithTipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${spacing.md}px;
`;
